export default {
  // 广告概览接口
  getShopSummary: {
    url: '/operationads/adSummary/getShopSummary',
    method: 'post',
    desc: '广告概览-初始数据'
  },
  getCampaignTopList: {
    url: '/operationads/adSummary/campaignTop/list',
    method: 'post',
    desc: '广告概览-广告活动'
  },
  getKeywordTopList: {
    url: '/operationads/adSummary/keywordTop/list',
    method: 'post',
    desc: '广告概览-关键词'
  },
  getAsinTopList: {
    url: '/operationads/adSummary/asinTop/list',
    method: 'post',
    desc: '广告概览-商品'
  },
  getSummary: {
    url: '/operationads/adSummary/getSummary',
    method: 'post',
    desc: '广告概览-图表总计数据'
  },
  getShopDetails: {
    url: '/operationads/adSummary/getShopDetails',
    method: 'post',
    desc: '广告概览-投放时间'
  },
  getAdHourDetails: {
    url: '/operationads/adSummary/getAdHourDetails',
    method: 'post',
    desc: '广告概览-投放时间-小时纬度'
  },
}
